import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class PaymentHistoryRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/payment-history(/)")
    route () {
        System.import("./index").then(View => {
            const view = new View.default();

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default PaymentHistoryRoute;



// WEBPACK FOOTER //
// ./public/domain/views/payment-history/payment-history.route.js